import Controler from '../base/Controler';
import Circle from './Circle';

class CircleControler extends Controler {
  private circles: Circle[] = [];
  private container: HTMLElement | null = null;
  constructor() {
    super();
    this.container = document.querySelector('.circles');
    this.circles = this.initCircles();
    this.initScrollListener();
    this.updateCirclePositions();
  }

  private initCircles(): Circle[] {
    const circlesArr: Circle[] = [];
    const els = this.selectElements('.circle');

    els.forEach(el => {
      const circle = new Circle(el);
      circlesArr.push(circle);
    });

    return circlesArr;
  }

  private initScrollListener(): void {
    if (!this.container) {
      return;
    }
    window.addEventListener('scroll', this.handleScroll);
  }

  private handleScroll = (): void => {
    if (!this.container) {
      return;
    }
    this.updateCirclePositions();
  };

  private updateCirclePositions(): void {
    const scrolled = window.scrollY || document.documentElement.scrollTop;
    this.circles.forEach(circle => {
      circle.updatePosition(scrolled);
    });
  }
}

export default CircleControler;
